export const getTransactionCategoryFormattedValue = (value: string[]): string => {
  return value.join(', ');
}
